import {combineReducers} from 'redux';

import auth from './AuthReducer';
import user from './UserReducer';
import cart from './CartReducer';
import review from './ReviewReducer';
import loading from './LoadingReducer';
import notification from './NotificationReducer';

export const RESET_STATE = 'RESET_STATE';

const appReducer = combineReducers({
    auth,
    user,
    cart,
    review,
    notification,
    loading
});

/**
 * Resetting Redux State with a Root Reducer
 * https://alligator.io/redux/reset-state-redux/
 */
const rootReducer = (state, action) => {
    if (action.type === RESET_STATE) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
